import { render, staticRenderFns } from "./comments-list-item-stub.vue?vue&type=template&id=68742e57"
import script from "./comments-list-item-stub.vue?vue&type=script&lang=ts"
export * from "./comments-list-item-stub.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports